import { Component, ElementRef, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, NavigationExtras } from '@angular/router';
import { AuthGuardService } from 'src/app/shared/services/auth-guard.service';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { SignUpComponent } from 'src/app/pages/sign-up/sign-up.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserManagementServiceService } from 'src/app/admin/user-management/user-management-service.service';
import { environment } from '../../../../src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnChanges {
  isUserLoggedIn = false;
  isClicked = false;
  hideSidebar = false;

  isLoggedin = false;
  activeBtn = 'home';
  userData: any;
  rightMenuBar: any = [
    {state: '/home', label: 'Home', icon: '', isActive: true, isChecked: true},
    {
      state: '', label: 'Portal Management', icon: '',
      model: ['aboutUs', 'user', 'role', 'country', 'sector', 'msme', 'cms', 'category', 'subcategory', 'subcategoryreport', 'glossary', 'impactstories', 'inquiry', 'partners', 'teammember'], isActive: false, isChecked: false, subItem: [
      {subState: '/user-level', subLabel: 'Manage User Role', subIcon: '', isActive: false, model: ['role'], isChecked: false},
      {subState: '/manage-user', subLabel: 'User Management', subIcon: '', isActive: false, model: ['user'], isChecked: false},
      {
        subState: '/approval-request', subLabel: 'Approval Requests', subIcon: '',
        isActive: false, model: ['user'], isChecked: false, adminOnly: true
      },
      {
        subState: '/manage-portal', subLabel: 'Manage portal', subIcon: '', isActive: false,
        model: ['cms', 'category', 'subcategory', 'subcategoryreport', 'glossary', 'impactstories', 'inquiry', 'partners', 'teammember', 'aboutUs'], isChecked: false
      },
      {
        subState: '/master', subLabel: 'Manage Master Data', subIcon: '',
        isActive: false, model: ['country', 'sector', 'msme'], isChecked: false
      },
      {subState: '/subscribers', subLabel: 'Subscribers', icon: '', isActive: false, model: ['subscribe'], isChecked: false},
    ]},
    {state: '/prism', label: ' PRISM', icon: '', isActive: false, model: ['ipsa'], isChecked: false},
    {state: '/resources', label: 'Resources', icon: '', isActive: true, isChecked: false},
    {state: '/impact-stories', label: 'Impact Stories', icon: '', isActive: true, isChecked: false},
    {state: '/about-us', label: 'About Us', icon: '', isActive: true, isChecked: false},
    {state: '/ourpartners', label: 'Our Partners', icon: '', isActive: true, isChecked: false},
    {
      state: '', label: '', icon: '../../../assets/images/notification.svg',
      isActive: false, isChecked: false, model: ['communicationmapper']
    },
  ];
  subTabs: string[] = ['/user-level', '/manage-user', '/approval-request', '/add-user', '/user-policies'];
  resourceTab: string[] = ['cms', 'category', 'impactstories', 'glossary', 'inquiry', 'teammember', 'partners'];
  notificationList: any = [];
  currentDate: any;
  totalUnread: any = [];
  userobj: any = {};
  userAllDetails: any;
  showImage: any;
  totalCountNotification: any = [];
  tabType = 'all';
  unReadMessageCount: any;
  lineItemID: any;
  notificationClicked: any;
  isShowInbox = false;
  isShowCom = false;

  constructor(
    public router: Router, public dialog: MatDialog, private commonService: CommonServiceService,
    private authService: AuthGuardService, private snackBar: MatSnackBar, private route: ActivatedRoute,
    private userService: UserManagementServiceService, private elementRef: ElementRef
    ) {
      this.renderMenu();
      this.isShowCom = environment?.isShowCom;
     }

  ngOnInit(): void {

  }

  renderMenu(): void {
    this.authService.isLoggedin.subscribe(res => {
      this.isLoggedin = res;
    });

    this.route.queryParams.subscribe();

    this.userobj = JSON.parse(sessionStorage.getItem('userdata') || '{}');
    this.userService.isProfile.subscribe((res: any) => {
    if (res){
      this.getUserInfo();
    }
  });
    this.commonService.isCommunication.subscribe((res: any) => {
    if (res){
      this.getCommunicationList();
    }
  });
    this.userData = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    this.userData = this.userData?.length ? this.userData[0] : {'role.name': 'User', role_id: 2};
    this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      if (event?.url.includes('?')){
        const getCurrent: any = event?.url?.split('?');
        event.url = getCurrent;
      }
      event.url = event.url.replace(/\/\d+$/, '');
      this.rightMenuBar = this.rightMenuBar.map((el: any) => {
        if (this.subTabs.includes(event?.url) && el?.subItem?.length){
           el.isChecked = true;
           el?.subItem.forEach((e: any) => {
                e.isChecked = e.subState === event?.url;
              });
        }
        else{
          el.isChecked = el.state === event?.url;
        }
        return el;
      });
    }
  });
    const userPermission = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    const hasPermissionData = Array.isArray(userPermission) && userPermission.length > 0;
    if (hasPermissionData){
      this.rightMenuBar = this.updateIsActiveKeys(this.rightMenuBar, userPermission[0]);
    }
    this.isLoggedin = hasPermissionData;
    this.getCommunicationList();
  }

  ngOnChanges(changes: SimpleChanges): void{
    if (changes?.isTabChange && changes?.isTabChange?.firstChange === false){

    }

  }

  logoutUser(): void {
    sessionStorage.removeItem('userPermission');
    // LOGOUT API CALL
    this.commonService.logoutService().subscribe(res => {
      if (res.success){
        let localkeys: any = [];
        localkeys = Object.keys(sessionStorage);

        localkeys.forEach((value: any) => {
          sessionStorage.removeItem(value);
        });
        this.router.navigate(['/home']);
        this.isLoggedin = false;
      }
    }, (error) => {
      let localkeys: any = [];
      localkeys = Object.keys(sessionStorage);

      localkeys.forEach((value: any) => {
          sessionStorage.removeItem(value);
        });
      this.router.navigate(['/home']);
      this.isLoggedin = false;
    });
  }

  openDialog(): void {
    this.router.navigate(['home']);
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '530px',
      panelClass: 'login-dialog-class',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.isLoggedin = result?.isLoggedIn;
      if (result){
        this.openSnackBar(result?.message, '', true);
        this.renderMenu();
        window.location.reload();
      }

    });
  }

  openSignUpForm(): void {
    this.router.navigate(['home']);
    const dialogRef = this.dialog.open(SignUpComponent, {
      width: '750px',
      panelClass: 'signUp-dialog-class',
      disableClose: true,
    });
  }
  redirectUrl(url: string): void{
    if (url){
      this.rightMenuBar = this.rightMenuBar.map((el: any) => {
        el.isChecked = el?.state === url;
        return el;
      });
      this.router.navigate([url]);
    }
    else if (!url){
      this.rightMenuBar = this.rightMenuBar.map((el: any) => {
        el.isChecked = el?.subItem?.length;
        return el;
      });
    }
    this.rightMenuBar = this.rightMenuBar.map((el: any) => {
      if (el?.subItem?.length){
        el.isChecked = false;
        el?.subItem.forEach((e: any) => {
          e.isChecked = false;
        });
      }

      return el;
    });
  }
  updateIsActiveKeys(mainArray: any[], secondaryArray: any): any[] {
    return mainArray.map((mainItem: any) => {

      secondaryArray?.authenicationJson?.forEach((secondaryItem: any) => {
        let checkPermissionModule = false;
        checkPermissionModule = (secondaryItem?.isAction || secondaryItem?.is_checked) ||
          secondaryItem?.authentication.some((authItem: any) => authItem?.isAction);
        if (checkPermissionModule && (secondaryItem.model === 'communicationmapper')) {
        this.isShowInbox = true;
        }

        if (mainItem.hasOwnProperty('model') && mainItem.model.includes(secondaryItem.model)){
          if (checkPermissionModule) {
          mainItem.isActive = true;
          }

        }

        if (mainItem?.subItem?.length) {
          mainItem.subItem.forEach((subItem: any) => {
            if (subItem.model.includes(secondaryItem.model)) {
              if (checkPermissionModule) {
                const isAdmin = (JSON.parse(sessionStorage.getItem('userdata') || '{}'))?.userlevel_id === 1;
                if (!subItem.adminOnly || isAdmin) {
                  subItem.isActive = true;
                }
              }
            }
          });
        }
      });
      return mainItem; // Return the updated mainItem
    });
  }


  openSnackBar(message: any, action = '', bottom: boolean = false): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    ...!bottom && {verticalPosition: 'bottom',
    horizontalPosition: 'center'},

    panelClass: ['black-snack']
  });
}
redirectUrlSubChild(subChildUrl: string, parentModule: string): void {
  if (subChildUrl){
    this.rightMenuBar = this.rightMenuBar.map((el: any) => {
      if (el && el?.subItem?.length){
        el.subItem.forEach((e: any) => {
          e.isChecked = subChildUrl === e.subState;
        });
      }
      return el;
    });
    setTimeout(() => {
      this.rightMenuBar = this.rightMenuBar.map((el: any) => {
        if (el && el?.subItem?.length){
          el.subItem.forEach((e: any) => {
            if (el.label === parentModule){
              el.isChecked = el.subItem.some((subItem: any) => subChildUrl === subItem.subState);
            }
            else{
              el.isChecked = false;
            }
          });
        }
        else{
          el.isChecked = false;
        }
        return el;
      });
    }, 0);
    this.router.navigate([subChildUrl]);
  }
}
getCommunicationList(): void {

  // to remove calling when not logged in
  if (sessionStorage.getItem('token')) {
  this.commonService.communicaionList('', '', 0, true, 'receive', this.userData?.id).subscribe(res => {
    if (res.success){
      if (res.data?.length){
        res.data = res.data.map((el: any) => {
          el.is_Clickable = false;
          return el;
        });
      }
      if (res.data?.length){
        this.notificationList = res?.data.filter((ele: any) => ele.is_visible === false);
        this.unReadMessageCount = res?.is_visible;
      }else{
        this.unReadMessageCount = 0;
        this.notificationList = [];
      }
      this.getNameInitials(this.notificationList);
    }
  });
  }
}

getNameInitials(responseData: any): void {
  if (!responseData?.length) { return; }
  for (const item of responseData) {
      if (!item?.name) { continue; }
      const fullName = item.name;
      const initials = fullName.split(' ').map((name: any) => name[0]).join('').toUpperCase();
      item.nameInitials = initials;
      const color = Math.floor(0x1000000 * Math.random()).toString(16);
      item.color = '#' + ('000000' + color).slice(-6);
  }
}

markAllRead(): void {
  const payload = {
    markasread: true
  };
  this.commonService.markAllasRead(payload).subscribe((res: any) => {
    if (res.success){
      this.openSnackBar(res.message);

      this.getCommunicationList();
      this.commonService.isMarkAllRead.next(true);
    }
  });
}

openSidebar(item: {icon: string}): void {
  if (item.icon){
  this.hideSidebar = true;
  // Current date and time
  this.currentDate = new Date();

  this.getCommunicationList();
  }
}

toggle(): void {
  this.hideSidebar = false;
  this.getCommunicationList();

}

tabChange(status: any): void {
  this.tabType = status;
  if (status === 'all'){
    this.getCommunicationList();
  }else{
    this.totalCountNotification = [...this.notificationList];
    this.totalCountNotification = this.totalCountNotification.filter((ele: any) => ele.is_visible === false);
  }

}

getUserInfo(isPrefield: boolean= false): void {
  this.userService.getProfileDetailsById(this.userobj.id).subscribe((res: any) => {
    if (res.success){
      this.userAllDetails = res.data[0];
      this.showImage = this.userAllDetails.photo;
    }
  });
}
redirectCommunicationPage(item: any): void {
  this.communicationUpdate(item);
  this.hideSidebar = false;
  const navigationExtras: NavigationExtras = {
    queryParams: { id: item?.id },
  };
  this.router.navigate(['communications'], navigationExtras);
  this.commonService.notificationClicked.next(item?.id);
}

currentTime(item: any): string {
  const date1 = new Date(item?.updatedAt);
  const date2 = new Date();
  const timeDifference = date2.getTime() - date1.getTime();
  return this.formatTimeDifference(timeDifference);
}

formatTimeDifference(milliseconds: any): string {
  const minutes = Math.floor(milliseconds / 60000);
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours > 0) {
    return `${hours} hours, ${remainingMinutes} minutes`;
  } else {
    return `${remainingMinutes} minutes`;
  }
}

communicationUpdate(data: any): void {
  this.lineItemID = data.id;
  this.notificationList = this.notificationList.map((el: any) => {
    if (el?.id === data?.id){
      el.is_Clickable = true;
    }
    else{
      el.is_Clickable = false;
    }
    return el;
  });
  let dataVisible = data.is_visible;
  if (!data?.is_visible){
      dataVisible = true;
  }
  const payload = {
    subject: data?.subject,
    message: data?.message,
    sender_id: data?.sender_id,
    receiver_id: data?.receiver_id,
    createdBy: data?.createdBy,
    is_highlight: data?.is_highlight,
    is_visible: dataVisible,
    is_Clickable : true

  };

  this.commonService.communicationUpdate(data.id, payload).subscribe(res => {
    if (res.success){
      this.getCommunicationList();
    }
  });
}
}
